// Implements: F-IDN-026
/**
 * An invitation link shown once, read-only, with its own accessible name (v3 `.link-field`): what
 * the person copies by hand when the clipboard refuses, and what each issued invitation shows.
 */

import type { ReactElement, ReactNode } from "react";

import { Input } from "../../../shared/ui/atoms/Input";
import styles from "./Organization.module.css";

export interface LinkFieldProps {
  readonly id: string;
  readonly label: string;
  readonly value: string;
  /** A control beside the field (the issued links' "Copiar"). */
  readonly action?: ReactNode;
}

export function LinkField({ id, label, value, action }: LinkFieldProps): ReactElement {
  return (
    <div className={styles.linkField}>
      <label htmlFor={id} className={styles.srOnly}>
        {label}
      </label>
      <Input id={id} value={value} readOnly onChange={() => undefined} />
      {action}
    </div>
  );
}
